module.exports = __webpack_public_path__ + "media/images/backgrounds/glin-symbol-primary-c3d1a4550a3b3f3acafd061d07591536.png";